module.exports = __webpack_public_path__ + "static/img/bottomFont.bf0e8b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bottomFont.png
// module id = uEZk
// module chunks = 12